<div class="groupBasket-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <ng-container *ngIf="groupMember$ | async;let member">
      <div class="memberDetail-content--top title-margin">
        <div class="member-content">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="hypersoft-user-single.svg"></div>
          </div>
          <ng-container *ngIf="isOwner">
            <h2 class="title info-label" langkey="phRemoteOrder_MemberOrder_Detail_Owner_Label">
            </h2>
          </ng-container>
          <ng-container *ngIf="!isOwner">
            <h2 class="title info-label" [innerHtml]="setHeaderLabelGuest(member.name)"></h2>
          </ng-container>
          <div class="member-content__basket">
            <ng-container *ngIf="member.itemsCount>0 then InfoTemplate else EmptyInfoTemplate"></ng-container>
            <ng-template #InfoTemplate>
              <div class="group-basket_info">
                <p>
                  <span>{{itemsCount(member.itemsCount)}}</span>
                  <span class="middle-text" langkey="phRemoteOrder_MemberOrder_Detail_Basket_Label"></span>
                  <span>{{itemsAmount(member.itemsAmount)}}</span>
                </p>
              </div>
            </ng-template>
            <ng-template #EmptyInfoTemplate>
              <div class="info-label" langkey="phRemoteOrder_MemberOrder_Detail_Empty_Basket"></div>
            </ng-template>
          </div>
          <div class="member-content__state">
            <ng-container *ngIf="isOwner">
              <div class="selection-state">
                <span langkey="phRemoteOrder_Group_Set_State_Ready"></span>
                <mat-checkbox class="checkItems custom-ripple" [checked]="member.stateReady"
                  (change)="changeStateReady(member.userId,$event)">
                </mat-checkbox>
              </div>
            </ng-container>
            <ng-container *ngIf="!isOwner">
              <span langkey="phRemoteOrder_Group_Member_State"></span>
              <span *ngIf="member.stateReady" class="text state"
                langkey="phRemoteOrder_Group_Member_State_Ready"></span>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="groupMemberItems$ | async; let  groupMemberItems">
      <div class="basket">
        <div class="col">
          <div class="ya-item-list-contaner">
            <ng-container *ngFor="let basketItems of groupMemberItems">
              <ng-container *ngFor="let basketItem of basketItems.items; let i = index">
                <ya-basketItemCard [basketItem]="basketItem" [canModifyBasket]="isOwner"></ya-basketItemCard>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>